"use client"

// Per-page pricing-currency provider. Server marketing pages resolve the
// currency from headers (via getPricingCurrencyFromHeaders) and wrap their
// subtree in <PricingCurrencyProvider value="INR" | "USD">. Client
// components below the provider call usePricingCurrency() / usePriceLabels()
// to render the right symbols without prop-drilling currency through every
// section.
//
// Default fallback is "USD" — same default getPricingCurrencyFromCountryCode
// returns for unknown geo. A client component that mounts outside any
// provider (tests, isolated previews) will still render reasonable copy.

import { createContext, useContext, type ReactNode } from "react"
import { getMarketingPriceLabels, type MarketingPriceLabels } from "@/lib/config/marketing-prices"
import type { PricingCurrency } from "@/lib/config/plans"

const PricingCurrencyContext = createContext<PricingCurrency>("USD")

export function PricingCurrencyProvider({
  value,
  children,
}: {
  value: PricingCurrency
  children: ReactNode
}) {
  return <PricingCurrencyContext.Provider value={value}>{children}</PricingCurrencyContext.Provider>
}

export function usePricingCurrency(): PricingCurrency {
  return useContext(PricingCurrencyContext)
}

export function usePriceLabels(): MarketingPriceLabels {
  return getMarketingPriceLabels(useContext(PricingCurrencyContext))
}
